module.exports = __webpack_public_path__ + "images/emoji/collision.2d5cc3d9ead27a2ce63d.png";